export default __webpack_public_path__ + "static/media/kitchen5-afterC-1024w.31c454cb.png";